/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Open360EntitiesRetailerApiBillingStatementListItem {
    DateTime?: Date;
    Amount?: number;
    InvoiceID?: number;
    InvoiceNumber?: string;
    /**
     * 1 = Visa, 2 = MasterCard
     */
    CardType?: Open360EntitiesRetailerApiBillingStatementListItem.CardTypeEnum;
    CardNumber?: string;
    /**
     * 0 = Schedule, 1 = LimitReached, 2 = Retry, 3 = JispPayCommissionThreshold, 4 = JispPayCommissionRefund
     */
    Reason?: Open360EntitiesRetailerApiBillingStatementListItem.ReasonEnum;
}
export namespace Open360EntitiesRetailerApiBillingStatementListItem {
    export type CardTypeEnum = 1 | 2;
    export const CardTypeEnum = {
        NUMBER_1: 1 as CardTypeEnum,
        NUMBER_2: 2 as CardTypeEnum
    }
    export type ReasonEnum = 0 | 1 | 2 | 3 | 4;
    export const ReasonEnum = {
        NUMBER_0: 0 as ReasonEnum,
        NUMBER_1: 1 as ReasonEnum,
        NUMBER_2: 2 as ReasonEnum,
        NUMBER_3: 3 as ReasonEnum,
        NUMBER_4: 4 as ReasonEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360EntitiesRetailerApiBillingStatementListItem.ts